import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loginStatus: false,
  refreshCount: 0,
  user: {
    id: '',
    name: '',
    email: '',
    emailVerified: null,
    phone: '',
    organization: '',
    role: '',
    idToken: null
  },
  limitedAccess: false,
};

export const appSlice = createSlice({
  name: 'updateUserState',
  initialState,
  reducers: {
    resetUser: (state) => {
      return {
        ...initialState,
        limitedAccess: false
      };
    },
    setFbUser: (state, action) => {
      state.fbUser = JSON.parse(action.payload);
    },
    setIdToken: (state, action) => {
      // console.log('### --- user.slice setIdToken:', action.payload === state.user.idToken ? 'SAME' : 'DIFFERENT')
      state.user.idToken = action.payload;
      state.refreshCount = state.refreshCount + 1;
      // console.log('### --- user.slice state.refreshCount:', state.refreshCount)
    },
    setUser: (state, action) => {
      // console.log('===> REDUX setUser:', action.payload)
      // state.user = action.payload;
      const user = JSON.parse(action.payload);
      state.user.email = user.email;
      state.user.emailVerified = user.emailVerified;
      // console.log('setUser: ', user)
    },
    setLoginStatus: (state, action) => {
      state.loginStatus = action.payload;
    },
    // setRrefreshCount: (state, action) => {
    //   state.refreshCount = state.refreshCount + 1;
    //   console.log('### state.refreshCount:', state.refreshCount)
    // },
    setId: (state, action) => {
      state.user.id = action.payload;
    },
    setName: (state, action) => {
      state.user.name = action.payload;
    },
    setEmail: (state, action) => {
      state.user.email = action.payload;
    },
    setEmailVerified: (state, action) => {
      state.user.emailVerified = action.payload;
    },
    setPhone: (state, action) => {
      state.user.phone = action.payload;
    },
    setOrganization: (state, action) => {
      state.user.organization = action.payload;
    },
    setRole: (state, action) => {
      // console.log('SETTING ROLE:', action)
      state.user.role = action.payload;
    },
    setLimitedAccess: (state, action) => {
      state.limitedAccess = action.payload;
    }
  }
});

// Action creators are generated for each case reducer function
export const {
  resetUser,
  setFbUser,
  setUser,
  setName,
  setEmail,
  setRole,
  setOrganization,
  setLoginStatus,
  setEmailVerified,
  setIdToken,
  setRrefreshCount,
  setLimitedAccess
} = appSlice.actions;
// You must export the reducer as follows for it to be able to be read by the store.
export default appSlice.reducer;
